import '@babel/polyfill'
import Es6Promise from 'es6-promise'
import Vue from "vue"
import App from './App.vue'
import router from './router'
import store from './store'
import Element from "element-ui";
import BaiduMap from 'vue-baidu-map'
import "./style/element-variables.scss";
import "./style/default.css"
// import "./style/layer.css"
import "./style/page.css"
import * as API from "@/api/index";
import moment from "moment";
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { utils, dict } from "@/utils";
import myComponents from "@/components/install.js";
require('es6-promise').polyfill()
Es6Promise.polyfill()
Vue.config.productionTip = false

Vue.prototype.$utils = utils;
Vue.prototype.$dict = dict;
Vue.prototype.$moment = moment;
Vue.prototype.$store = store;
Vue.prototype.$API = API;
Vue.filter('formatDate', function (value, type) {
  let date = value.split(" ")[0]
  let arr = date.split("-")
  if (type == "year") {
    return arr[0]
  } else {
    return arr[1] + "-" + arr[2]
  }
})
Vue.use(BaiduMap, {
  ak: '175015a6227dca437e13abb9a6e845ac'
});
Vue.use(Element);
Vue.use(VueAwesomeSwiper)
Vue.use(myComponents)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
